import React, { FC } from 'react'
import { FontWeightType, Text, TextType } from 'LibNeo'
import { formatDateAndTime } from 'Helpers'
import { Circle, HistoryContent, Line, WrapperHistory } from './styled'

interface ComponentProps {
	date: string
	comment: string
	lastEvent: boolean
}

export const UpdatingHistory: FC<ComponentProps> = ({ comment, date, lastEvent }) => {
	return (
		<WrapperHistory>
			<Line lastEvent={lastEvent}>
				<Circle />
			</Line>

			<HistoryContent>
				<Text type={TextType.CAPTION} fontWeight={FontWeightType.MEDIUM} colorIndex={8}>
					{comment}
				</Text>
				<Text type={TextType.CAPTION} colorIndex={5}>
					{formatDateAndTime(date)}
				</Text>
			</HistoryContent>
		</WrapperHistory>
	)
}
